import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import ShopLocalCoupon from "./ShopLocalCoupon";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";

const ShopLocalCouponPage = () => {
  // state to make the tab active
  const [currentTab, setcurrentTab] = useState("");
  // state to toggle the loader page
  const [loading, setLoading] = useState(true);

  const path = window.location.href;
  const endPath = path.split("/")[4];

  // hooks to use the end path to set the current tab
  useEffect(() => {
    if (endPath === "coupon") {
      setcurrentTab("coupon");
    }
    setTimeout(() => {
      setLoading(false)
    }, 300);
  }, []);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 shopLocalAi">
          <p className="page-text dashboard">
            <Link to={"/shop-local-AI/voucher"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">CommunityX AI</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                to={"/shop-local-AI/business-profile"}
                className={"tabs_li"}
              >
                Business Profile
              </NavLink>
              <NavLink to={"/shop-local-AI/voucher"} className={"tabs_li"}>
                Voucher
              </NavLink>
              <NavLink
                to={""}
                className={currentTab === "coupon" ? " activeTab" : "tabs_li"}
              >
                Coupon
              </NavLink>
            </div>

            <div className="mt-3">
              <ShopLocalCoupon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopLocalCouponPage;
